import React, { useEffect, useState } from "react";
import { TextField, Typography } from "@mui/material";
import "./Login.css";
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../Assets/riwa-admin-logo.svg";
import InputField from "../Components/inputfield";
import ButtonComponent from "../Components/buttton";
import axios from "axios";
import { GetSingleData, SignIn } from "../NetworkCalls/Admin/ServerReq";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { toast } from "react-toastify";

const Login = () => {
  const history = useNavigate();
  const [loader, setLoader] = useState(false);
  const [Error, setError] = useState("");

  const [data, setData] = useState({
    admin_email: "",
    admin_password: "",
  });

  const isAdmin = localStorage.getItem("uid");

  const isAdminFunc = async () => {
    const docRef = await getDoc(doc(db, "AppInfo", "settings"));
    if (isAdmin == docRef.data().admin_uid) {
      history({ pathname: "/dashboard/resturants" });
    }
    return null;
  };

  useEffect(() => {
    isAdminFunc();
  }, [isAdmin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    //  console.log("e.target",e.target.value)
    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  // const handleSubmit=(event)=>{

  // }
  const handlePermissions = (arr) => {
    console.log(arr);
    return arr.includes("Admin") || arr.includes("Admins");
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setLoader(true);
  //   setError("");
  //   // console.log(data)
  //   SignIn(data)
  //     .then((res) => {
  //       console.log("res==========");
  //       console.log(res);
  //       history({ pathname: "/dashboard/resturants" });
  //       setLoader(false);
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //       setLoader(false);
  //     });
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoader(true);
    setError("");
    try {
      const response = await GetSingleData("AppInfo", "settings");
      if (
        response.admin_email === data.admin_email &&
        response.admin_password === data.admin_password
      ) {
        localStorage.setItem("uid", response.admin_uid);
        history({ pathname: "/dashboard/resturants" });
        setLoader(false);
      } else {
        toast.error("Invalid credentials");
      }
    } catch (error) {
      setLoader(true);
      setError(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className="main_container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <div className='header'>
          <h1>Welcome</h1>
        </div> */}

        <div className="login_container">
          <div
            style={{
              margin: "40px 20px 10px 20px",
              width: "100%",
              textAlign: "center",
            }}
          >
            <h1>Welcome</h1>
            <Typography sx={{ color: "#757575" }}>
              Kalamazoo Dashboard
            </Typography>
          </div>
          <form onSubmit={handleSubmit} style={{ width: "90%" }}>
            <div className="textfields_div">
              <InputField
                type="email"
                name="admin_email"
                value={data.admin_email}
                placeholder={"Email"}
                onChange={handleChange}
              />
            </div>

            <div className="textfields_div">
              <InputField
                type="password"
                name="admin_password"
                value={data.admin_password}
                placeholder={"Password"}
                onChange={handleChange}
              />
            </div>

            <div>
              <ButtonComponent loader={loader} name="Login" type="submit" />
              <div
                style={{
                  color: "#E12F2F",
                  fontWeight: 500,
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                {Error}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
